import React, { Component }  from 'react';
import del from '../img/delete.svg';
import plus from '../img/plus.svg';

export default class Paperwork extends Component {
    constructor(props) {
		super(props);
		this.state = {
			active: false,
			editing: false,
			loading: false,
		};
	}

	edit = (e) => {
		this.setState({editing: true, loading: false, reviewStart: this.props.data.Paperwork.reviewStart, reviewEnd: this.props.data.Paperwork.reviewEnd })
	}
	editStart =(e)=> {
		this.setState({editing: true, loading: false, reviewStart: e.currentTarget.value})
	}
	editEnd=(e)=> {
		this.setState({editing: true, loading: false, reviewEnd: e.currentTarget.value})
	}
	conf =()=>{
		this.setState({loading: true})
		this.props.ws.send(JSON.stringify({route: 'editPaperwork', reviewStart: this.state.reviewStart, reviewEnd: this.state.reviewEnd }))
	}
	cancel = () => {
		this.setState({editing: false, loading: false, setting: false})
	}

	componentWillReceiveProps(nextProps) {
		if(this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
			var edit = ""
			if (this.state.editing) {
				edit = (
					<div className="blackout" tabIndex="1" autoFocus onKeyUp={this.checkEnter}>
						<div className="pop" >
							<div className="viewCloser" onClick={this.cancel}>X</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.reviewStart} onChange={this.editStart} ></input>
								<span className="inputBar"></span><label className="textLabel">Start Range</label>
							</div>

							<div className="snazzyInputBox">
								<input className="textInput" type="text" required value={this.state.reviewEnd} onChange={this.editEnd} ></input>
								<span className="inputBar"></span><label className="textLabel">End Range</label>
							</div>

							<div className="error" style={{padding: '15px'}}>{this.state.error}</div>

							{this.state.loading ? <div className="loader"></div> : <div className="button"  onClick={this.conf}>Confirm Verbiage</div>}
						</div>
					</div>
				)
			}

			return (
				<div className="viewContent" id="reportView" >

					<div  style={{overflow: 'auto',  height: 'calc(100% - 85px)'}}>
                        <div style={{textAlign:'center', fontSize: 22, padding: '25px'}}>If you have submitted paperwork to our office, we are currently reviewing information</div>
                        <div style={{textAlign:'center', fontSize: 28, cursor: 'pointer', color: '#2A6AA9',padding: '25px' }} onClick={this.edit}>{this.props.data.Paperwork.reviewStart}</div>
                        <div style={{textAlign:'center', fontSize: 22, padding: '25px'}}>to</div>
                        <div style={{textAlign:'center', fontSize: 28, cursor: 'pointer', color: '#2A6AA9', padding: '25px'}} onClick={this.edit}>{this.props.data.Paperwork.reviewEnd}</div>
                        <div style={{textAlign:'center', fontSize: 22, padding: '25px'}}>from the date received.</div>
						{edit}
					</div>
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/Views/Paperwork.js